export default __webpack_public_path__ + "static/media/gamepad.7992ff8a.svg";